import { ChemistryRangesPage } from "./ChemistryRangesPage";

const ChemistryRanges = () => {
	return <ChemistryRangesPage />;
};
export default ChemistryRanges;
